import { BillingApi } from '@/api/billing.api';
import { BankBoletoAccount, CreateBoleto } from '@/models/billing.model';
import { LoadingService } from '@/services/loading.service';
import { NotificationService } from '@/services/notification.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';


export interface DialogBoletoData {
  invoicingId: string;
}

@Component({
  selector: 'app-dialog-boleto',
  templateUrl: './dialog-boleto.component.html',
  styleUrl: './dialog-boleto.component.scss'
})
export class DialogBoletoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  bankAccountControl = new FormControl(null, Validators.required);
  bankBoletoId = "";
  bankAccounts: any[] = [{ name: 'teste', id: 'aaaaaaaaaaaaa' }];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogBoletoData,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogBoletoComponent>,
    private formBuilder: FormBuilder,
    private billingApi: BillingApi,
    private notificationService: NotificationService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.bankAccountControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((bankAccount: any) => {
        this.bankBoletoId = bankAccount.id;
      });

    this.billingApi.getBankBoletoAccounts().then((resp) => {
        this.bankAccounts = resp;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  generateBoleto() {
    if (!this.bankBoletoId) return;
    let request = {
      bankBoletoId: this.bankBoletoId,
      invoicingId: this.data.invoicingId
    } as CreateBoleto;

    this.loadingService.show();
    this.billingApi.createBoleto(request).then((resp) => {
      this.notificationService.showSuccessMessage("Boleto gerado com sucesso!");
      window.open(resp.data.url, '_blank');
      this.loadingService.hide();
      this.onCancel();
    }).catch(() => {
      this.loadingService.hide();
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
